import User from '@dehaat/kisan-app-bl/models/User'

import Mixpanel from '@/utils/analytics/mixpanel'
import { runWhenMoengageReady } from '@/utils/moengage'

import * as GA from './googleAnalytics'
import * as FB from './pixelAnalytics'
import { CartCaptureEvent, PurchaseEvent } from './types'

export { flattenEcommerceParamsForMoengage, mirrorEcommerceEventToMoengage, trackPageView, trackProductEvent } from './trackProductEvent'

export const capturePurchaseEvent = (eventData: PurchaseEvent) => {
  GA.capturePurchaseEvent(eventData)
  // FB.capturePurchaseEvent(eventData)
}

export const captureCartEvent = (eventData: CartCaptureEvent) => {
  // Intentional dual MoEngage/GA tracking: UI emits AddToCartClick; cart state emits add_to_cart.
  GA.CaptureUpdateCartEvent(eventData)
  if (eventData.eventType === 'add_to_cart') {
    FB.captureCartEvent(eventData)
  }
}

export const loginEvent = (userInfo: User) => {
  if (typeof window !== 'undefined' && window.gtag != null) {
    window.gtag('set', { user_id: userInfo.auth_id })
  }

  Mixpanel.identify(userInfo.auth_id || '')
  Mixpanel.setUser({
    username: userInfo.username,
    name: userInfo.full_name,
    email: userInfo.email,
    mobile: userInfo.phone_number,
  })

  runWhenMoengageReady(() => {
    if (userInfo.auth_id) {
      Moengage.add_unique_user_id(userInfo.auth_id)
    }
    if (userInfo.phone_number) {
      Moengage.add_mobile(userInfo.phone_number)
      Moengage.add_user_attribute('UserMobile', userInfo.phone_number)
    }
  })
}
